module.exports = __webpack_public_path__ + "media/zcv.735a8360.mp4";